import React from 'react'
import Gallery from './Gallery';

import Hero from './Hero';

function Home() {
    return (
        <div>
            <Hero />
            <Gallery />
        </div>
    )
}

export default Home
